/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {ErrorModalComponent as ɵa} from './error/error.service';
export {TruncatePipe as ɵb} from './shared/pipes/truncate.pipe';